import {Component} from '@angular/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent {
  constructor() {
    document.title = 'SRiMS ' + `[v${environment.version}]`;
  }
}
